module.exports = __webpack_public_path__ + "img/declined.cd34bf72.svg";